import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class InformacionService {

  info: any = {};
  equipo: any[] = [];
  servicios: any[] = [];
  cargada: boolean = false;
  equipo_cargado: boolean = false;
  constructor( public http: HttpClient ) {
    this.load_info();
    this.load_equipo();
    this.load_servicios();
  }

  public load_info() {
    this.http.get('assets/data/info.pagina.json')
      .subscribe( data => {
        this.info = data;
        this.cargada = true;
      })
  }

  public load_equipo() {
    // this.http.get('https://website-47b95.firebaseio.com/equipo.json')
    this.http.get('assets/data/equipo.pagina.json')
      .subscribe( (data: any) => {
        this.equipo = data;
        this.equipo_cargado = true;
      })
  }

  public load_servicios() {
    this.http.get('assets/data/servicios.pagina.json')
      .subscribe( (data: any) => {
        this.servicios = data;
        this.cargada = true;
      })
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/services/informacion.service.ts